import { accountStore } from '@/services/auth/store';
import { Region } from '@/services/auth/types';
import { getAppVersion } from '@/utils/version';
import type { RumContext } from './types';

/**
 * Context stamped onto the beacon at flush time. The account may not be
 * loaded yet (pre-auth pages, abandoned loads) — anonymous defaults apply.
 * Masqueraded sessions are labeled, not dropped: on staging they're exactly
 * the pre-release traffic we want.
 */
export function getRumContext(): RumContext {
  const account = accountStore.get();
  return {
    ui_version: getAppVersion(),
    env: __CIO_ENV__,
    dc: account?.region === Region.EU ? 'eu' : 'us',
    is_masq: account?.is_masq === true,
    account_id: account == null ? undefined : String(account.id),
  };
}
